import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './organizationFormInitialState';
import {
  _setNewOrganizationForm,
  _setOrgId,
  _setOrgKey,
  _setOrganizationName,
  _setAlternateName,
  _setAccountingContactId,
  _setFacilityCoordinatorContactId,
  _setCity,
  _setParentOrganizationId,
  _setAdministrativeContactId,
  _setInvoiceVerificationContactId,
  _setWCare,
  _setParole,
  _setPrison,
  _setOther,
  _setCbp,
  _setSap,
  _setStop,
  _setVendor,
  _setInactive,
  _setOrgDateCreate,
  _setOrgDateEdit,
  _setOrgCreatedById,
  _setOrgEditedById,
} from './organizationFormActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationForm = createAsyncThunk(
  'stop/getOrganizationForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationFormSlice = createSlice({
  name: 'stop/organizationForm',
  initialState,
  reducers: {
    //newOrganizationForm: (state, action) => action.payload,
    setNewOrganizationForm: _setNewOrganizationForm,
    setOrgId: _setOrgId,
    setOrgKey: _setOrgKey,
    setOrganizationName: _setOrganizationName,
    setAlternateName: _setAlternateName,
    setAccountingContactId: _setAccountingContactId,
    setFacilityCoordinatorContactId: _setFacilityCoordinatorContactId,
    setCity: _setCity,
    setParentOrganizationId: _setParentOrganizationId,
    setAdministrativeContactId: _setAdministrativeContactId,
    setInvoiceVerificationContactId: _setInvoiceVerificationContactId,
    setWCare: _setWCare,
    setParole: _setParole,
    setPrison: _setPrison,
    setOther: _setOther,
    setCbp: _setCbp,
    setSap: _setSap,
    setStop: _setStop,
    setVendor: _setVendor,
    setInactive: _setInactive,
    setOrgDateCreate: _setOrgDateCreate,
    setOrgDateEdit: _setOrgDateEdit,
    setOrgCreatedById: _setOrgCreatedById,
    setOrgEditedById: _setOrgEditedById,
    resetOrganizationForm: (state) => initialState,
  },
  extraReducers: {
    [getOrganizationForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  //newOrganizationForm,
  setNewOrganizationForm,
  setOrgId,
  setOrgKey,
  setOrganizationName,
  setAlternateName,
  setAccountingContactId,
  setFacilityCoordinatorContactId,
  setCity,
  setParentOrganizationId,
  setAdministrativeContactId,
  setInvoiceVerificationContactId,
  setWCare,
  setParole,
  setPrison,
  setOther,
  setCbp,
  setSap,
  setStop,
  setVendor,
  setInactive,
  setOrgDateCreate,
  setOrgDateEdit,
  setOrgCreatedById,
  setOrgEditedById,
  resetOrganizationForm,
} = organizationFormSlice.actions;

export default organizationFormSlice.reducer;
